/**
 * GuideExample — boxed worked example. Distinct visual from a regular
 * callout so the user knows it's a concrete scenario they can read once
 * and reuse mentally.
 */
import React from 'react';
import { Box, Typography } from '@mui/material';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import { useAppTheme } from '../../hooks/useAppTheme';

interface Props {
  title?: string;
  children: React.ReactNode;
}

const GuideExample: React.FC<Props> = ({ title = 'Example', children }) => {
  const { C, isDark } = useAppTheme();
  return (
    <Box
      sx={{
        my: 2,
        borderRadius: 1.5,
        bgcolor: isDark ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.025)',
        border: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Box
        sx={{
          display: 'flex', alignItems: 'center', gap: 0.75,
          px: 1.5, py: 0.75,
          borderBottom: '1px solid',
          borderColor: 'divider',
          color: C.accent,
        }}
      >
        <PlayCircleOutlineIcon sx={{ fontSize: 16 }} />
        <Typography sx={{ fontSize: '0.72rem', fontWeight: 700, textTransform: 'uppercase', letterSpacing: 0.5 }}>
          {title}
        </Typography>
      </Box>
      <Box sx={{ p: 1.5, fontSize: '0.88rem', lineHeight: 1.6 }}>
        {children}
      </Box>
    </Box>
  );
};

export default GuideExample;
